"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CnTextEllipsis = void 0;
var React = _interopRequireWildcard(require("react"));
require("cn-next/es/icon/style");
var _icon = _interopRequireDefault(require("cn-next/es/icon"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("cn-next/es/balloon/style");
var _balloon = _interopRequireDefault(require("cn-next/es/balloon"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Tooltip = _balloon["default"].Tooltip;
var CnTextEllipsis = function CnTextEllipsis(_ref) {
  var children = _ref.children,
    style = _ref.style,
    line = _ref.line,
    className = _ref.className,
    _ref$showTooltip = _ref.showTooltip,
    showTooltip = _ref$showTooltip === void 0 ? false : _ref$showTooltip,
    _ref$showFolder = _ref.showFolder,
    showFolder = _ref$showFolder === void 0 ? false : _ref$showFolder,
    arrowUp = _ref.arrowUp,
    arrowDown = _ref.arrowDown;
  var textRef = React.useRef(null);
  var _React$useState = React.useState(false),
    isOverflow = _React$useState[0],
    setIsOverflow = _React$useState[1];
  var _React$useState2 = React.useState(false),
    showAll = _React$useState2[0],
    setShowAll = _React$useState2[1];
  React.useEffect(function () {
    if (!(textRef !== null && textRef !== void 0 && textRef.current)) return;
    if (textRef.current.scrollHeight > textRef.current.offsetHeight) {
      setIsOverflow(true);
    }
  }, []);
  var handleToggleFold = function handleToggleFold() {
    setShowAll(!showAll);
  };
  var content = /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])('cn-ui-text-clip', {
      fold: showFolder && isOverflow
    })
  }, /*#__PURE__*/React.createElement("div", {
    ref: textRef,
    className: (0, _classnames["default"])([className, {
      'cn-ui-text-clip-inner': !showAll
    }]),
    style: (0, _extends2["default"])({}, style, {
      WebkitLineClamp: line
    }),
    title: children
  }, children), showFolder && isOverflow ? /*#__PURE__*/React.createElement("span", {
    className: "cn-ui-text-clip-fold",
    onClick: handleToggleFold
  }, arrowUp && arrowDown ? /*#__PURE__*/React.createElement(React.Fragment, null, showAll ? arrowUp : arrowDown) : /*#__PURE__*/React.createElement(_icon["default"], {
    type: showAll ? 'arrow-up' : 'arrow-down'
  })) : null);
  if (showTooltip && isOverflow) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      trigger: content,
      align: "tl"
    }, children);
  }
  return content;
};
exports.CnTextEllipsis = CnTextEllipsis;
CnTextEllipsis.defaultProps = {
  line: 2
};
CnTextEllipsis.displayName = 'CnTextClip';